module.exports = __webpack_public_path__ + "static/media/7.9132afe2.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/eyebrowes/7.png
// module id = 507
// module chunks = 0